/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import { sentenceCase, capitalCase } from 'change-case';
import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { useTheme } from '@mui/material/styles';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Switch,
  Tabs,
  Button,
  Tab,
  Box,
  Stack,
  Chip,
  Tooltip,
  IconButton,
  useMediaQuery,
  Grid,
  Divider,
  Collapse,
} from '@mui/material';

// format
import FormControlLabel from '@mui/material/FormControlLabel';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmptyContent from '../../components/EmptyContent';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// format number
import { fCurrency } from '../../utils/formatNumber';
// sections
import { TransHead, PlanToolbar } from '../../sections/admin/user/list';
import Iconify from '../../components/Iconify';
// axios
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'my_trans_id', label: 'System ID', alignRight: false },
  { id: 'disco_name', label: 'Disco Name', alignRight: false },
  { id: 'meter_type', label: 'Meter Type', alignRight: false },
  { id: 'meter_number', label: 'Meter Number', alignRight: false },
  { id: 'customer_name', label: 'Customer Name', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'charges', label: 'charges', alignRight: false },
  { id: 'oldbal', label: 'Old Bal', alignRight: false },
  { id: 'newbal', label: 'New Bal', alignRight: false },
  { id: 'transid', label: 'Client Reference ID', alignRight: false },
  { id: 'purchased_code', label: 'Purchased Code', alignRight: false },
  { id: 'system', label: 'System', alignRight: false },
  { id: 'date', label: 'Purchased Date', alignRight: false },
  { id: 'plan_status', label: 'Plan Status', alignRight: false },
  { id: 'invioce', label: 'INVIOCE', alignRight: false },
];

const ACCOUNT_TABS = [
  {
    value: 'ALL',
    label: 'ALL',
  },
  {
    value: 1,
    label: 'Successful',
  },
  {
    value: 0,
    label: 'Processing',
  },
  {
    value: 2,
    label: 'Failed',
  },
];

// ----------------------------------------------------------------------

export default function BillTransaction() {
  const theme = useTheme();
  const { themeStretch } = useSettings();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [load, SetLoad] = useState(true);
  const [totalPage, SetTotal] = useState(0);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, Setdense] = useState(false);
  const [isNotFound, SetNotFound] = useState(false);
  const [status, setStatus] = useState('ALL');
  const [expandedRows, setExpandedRows] = useState({});
  const AccessToken = window.localStorage.getItem('accessToken');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [copiedId, setCopiedId] = useState(null);

  const initialize = useCallback(
    async (pag, adex = 5, status, search) => {
      let adex_page;
      if (pag > page) {
        adex_page = pag + 1;
      } else {
        adex_page = pag;
      }
      SetLoad(true);

      try {
        const data = await axios.get(
          `/api/system/all/trans/${AccessToken}/secure?page=${adex_page}&adex=${adex}&status=${status}&search=${search}&database_name=bill_trans`
        );
        setUserList(data.data?.bill_trans?.data);
        SetTotal(data.data?.bill_trans?.total);
        SetLoad(false);
        setPage(pag);
        SetNotFound(data.data?.bill_trans?.total === 0);
      } catch (_) {
        SetLoad(false);
        setUserList([]);
      }
    },
    [AccessToken, page]
  );

  useEffect(() => {
    initialize(page, rowsPerPage, status, filterName);
  }, [initialize, page, rowsPerPage, status, filterName]);

  const handleChangeRowsPerPage = useCallback(
    (event) => {
      const newRowsPerPage = parseInt(event.target.value, 10);
      setRowsPerPage(newRowsPerPage);
      initialize(0, newRowsPerPage, status, filterName);
      setPage(0);
    },
    [initialize, status, filterName]
  );

  const handleFilterByName = useCallback(
    async (filterName) => {
      setFilterName(filterName);
      setPage(0);
      if (filterName) {
        initialize(page, rowsPerPage, status, filterName);
      } else {
        initialize(page, rowsPerPage, status, filterName);
        SetNotFound(false);
        SetLoad(false);
      }
    },
    [initialize, page, rowsPerPage, status]
  );

  const handleChangeDense = useCallback((event) => {
    Setdense(event.target.checked);
  }, []);

  const handleRowToggle = useCallback((transid) => {
    setExpandedRows((prev) => ({
      ...prev,
      [transid]: !prev[transid],
    }));
  }, []);

  const handleStatusChange = useCallback(
    (event, value) => {
      setStatus(value);
      initialize(page, rowsPerPage, value, filterName);
    },
    [initialize, page, rowsPerPage, filterName]
  );

  const handlePageChange = useCallback(
    (event, newPage) => {
      initialize(newPage, rowsPerPage, status, filterName);
    },
    [initialize, rowsPerPage, status, filterName]
  );

  // Helper functions to avoid nested ternaries
  const getTabColor = (tabValue) => {
    const isLight = theme.palette.mode === 'light';
    if (status === tabValue) {
      return isLight ? theme.palette.text.primary : theme.palette.grey[900];
    }
    return theme.palette.text.secondary;
  };

  const getTabBackground = (tabValue) => {
    const isLight = theme.palette.mode === 'light';
    if (status === tabValue) {
      return isLight ? theme.palette.common.white : theme.palette.grey[700] || '#616161';
    }
    return 'transparent';
  };

  // Mobile Accordion Row Component for Bill
  const MobileAccordionRow = ({ row, expanded, onToggle }) => {
    const {
      system,
      customer_name,
      amount,
      oldbal,
      newbal,
      plan_date,
      transid,
      my_trans_id,
      plan_status,
      meter_number,
      disco_name,
      meter_type,
      token,
      charges,
    } = row;
    let statusProps = { label: '', color: 'default', icon: null };
    if (plan_status === 1) {
      statusProps = {
        label: 'Successful',
        color: 'success',
        icon: <Iconify icon="eva:checkmark-circle-2-fill" width={18} height={18} />,
      };
    } else if (plan_status === 0) {
      statusProps = {
        label: 'Processing',
        color: 'warning',
        icon: <Iconify icon="eva:clock-outline" width={18} height={18} />,
      };
    } else if (plan_status === 2) {
      statusProps = {
        label: 'Failed',
        color: 'error',
        icon: <Iconify icon="eva:close-circle-fill" width={18} height={18} />,
      };
    }
    return (
      <Card
        sx={{
          mb: 1,
          borderRadius: 2,
          boxShadow: 1,
          border: expanded ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
          transition: 'all 0.3s ease',
        }}
      >
        {/* Main Row - Always Visible */}
        <Box
          sx={{
            p: 2,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
          onClick={onToggle}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                {disco_name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {meter_type}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                label={statusProps.label}
                color={statusProps.color}
                icon={statusProps.icon}
                size="small"
                sx={{ fontWeight: 600 }}
              />
              <IconButton size="small">
                <Iconify icon={expanded ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} width={20} height={20} />
              </IconButton>
            </Box>
          </Stack>
        </Box>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box sx={{ px: 2, pb: 2 }}>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  System ID
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {my_trans_id}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => {
                      navigator.clipboard.writeText(my_trans_id);
                      setCopiedId(my_trans_id);
                      setTimeout(() => setCopiedId(null), 1200);
                    }}
                  >
                    {copiedId === my_trans_id ? (
                      <CheckCircleOutlineIcon fontSize="small" color="success" />
                    ) : (
                      <ContentCopyIcon fontSize="small" />
                    )}
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Meter Number
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {meter_number}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Customer Name
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {customer_name}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Amount
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  ₦{fCurrency(amount)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Charges
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  ₦{fCurrency(charges)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Old Balance
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  ₦{fCurrency(oldbal)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  New Balance
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  ₦{fCurrency(newbal)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Client Reference ID
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {transid}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Token
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {token}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  System
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {system}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Purchase Date
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                  {plan_date}
                </Typography>
              </Grid>
            </Grid>
            <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
              <Button
                variant="contained"
                component={RouterLink}
                to={`${PATH_DASHBOARD.general.invioce}/${my_trans_id}/bill`}
                sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
              >
                Generate Invoice
              </Button>
            </Stack>
          </Box>
        </Collapse>
      </Card>
    );
  };

  // Mobile and Desktop renderers
  const renderMobileView = () => {
    if (load) {
      return (
        <Box sx={{ mt: 2 }}>
          {[...Array(rowsPerPage)].map((_, idx) => (
            <Card key={idx} sx={{ mb: 1, p: 2, borderRadius: 2 }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ width: 100, height: 16, bgcolor: 'grey.200', borderRadius: 1, mb: 1 }} />
                  <Box sx={{ width: 80, height: 12, bgcolor: 'grey.200', borderRadius: 1 }} />
                </Box>
                <Box sx={{ width: 80, height: 24, bgcolor: 'grey.200', borderRadius: 1 }} />
              </Stack>
            </Card>
          ))}
        </Box>
      );
    }
    if (userList.length > 0) {
      return (
        <Box sx={{ mt: 2 }}>
          {userList.map((row) => (
            <MobileAccordionRow
              key={row.transid}
              row={row}
              expanded={expandedRows[row.transid] || false}
              onToggle={() => handleRowToggle(row.transid)}
            />
          ))}
        </Box>
      );
    }
    return (
      <Box sx={{ mt: 2 }}>
        <Card sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
          <EmptyContent
            title="No Bill Transactions"
            description="No electricity bill transactions found for your current filter."
            img="/upload/notfound.png"
          />
        </Card>
      </Box>
    );
  };

  const renderDesktopView = () => (
    <Scrollbar>
      <TableContainer sx={{ minWidth: 800 }}>
        <Table size={dense ? 'small' : 'medium'}>
          <TransHead order={'asc'} orderBy={'id'} headLabel={TABLE_HEAD} rowCount={userList.length} />
          {!load ? (
            <TableBody>
              {userList.map((row) => {
                const {
                  system,
                  customer_name,
                  amount,
                  oldbal,
                  newbal,
                  plan_date,
                  meter_type,
                  transid,
                  plan_status,
                  meter_number,
                  disco_name,
                  token,
                  charges,
                  my_trans_id,
                } = row;
                let statusProps = { label: '', color: 'default', icon: null };
                if (plan_status === 1) {
                  statusProps = {
                    label: 'Successful',
                    color: 'success',
                    icon: <Iconify icon="eva:checkmark-circle-2-fill" width={18} height={18} />,
                  };
                } else if (plan_status === 0) {
                  statusProps = {
                    label: 'Processing',
                    color: 'warning',
                    icon: <Iconify icon="eva:clock-outline" width={18} height={18} />,
                  };
                } else if (plan_status === 2) {
                  statusProps = {
                    label: 'Failed',
                    color: 'error',
                    icon: <Iconify icon="eva:close-circle-fill" width={18} height={18} />,
                  };
                }
                return (
                  <TableRow hover key={my_trans_id} tabIndex={-1} role="checkbox">
                    <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="subtitle2" noWrap>
                        {my_trans_id}
                      </Typography>
                    </TableCell>
                    <TableCell align="left">{disco_name}</TableCell>
                    <TableCell align="left">{meter_type}</TableCell>
                    <TableCell align="left">{meter_number}</TableCell>
                    <TableCell align="left">{customer_name}</TableCell>
                    <TableCell align="left">₦{fCurrency(amount)}</TableCell>
                    <TableCell align="left">₦{fCurrency(charges)}</TableCell>
                    <TableCell align="left">₦{fCurrency(oldbal)}</TableCell>
                    <TableCell align="left">₦{fCurrency(newbal)}</TableCell>
                    <TableCell align="left">{transid}</TableCell>
                    <TableCell align="left">{token}</TableCell>
                    <TableCell align="left">{system}</TableCell>
                    <TableCell align="left">{plan_date}</TableCell>
                    <TableCell align="left">
                      <Chip
                        label={statusProps.label}
                        color={statusProps.color}
                        icon={statusProps.icon}
                        size="small"
                        sx={{ fontWeight: 600 }}
                      />
                    </TableCell>
                    <TableCell align="left">
                      <Tooltip title="Generate Invoice">
                        <IconButton
                          color="primary"
                          component={RouterLink}
                          to={`${PATH_DASHBOARD.general.invioce}/${my_trans_id}/bill`}
                        >
                          <Iconify icon="eva:file-text-outline" width={22} height={22} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          ) : (
            <TableRow>
              <TableCell align="center" colSpan={5} sx={{ py: 3 }}>
                <Typography variant="body2">Loading ...</Typography>
              </TableCell>
            </TableRow>
          )}
          {isNotFound && (
            <TableRow>
              <TableCell align="center" colSpan={5} sx={{ py: 3 }}>
                <EmptyContent
                  title="No Data Transactions"
                  description="No data transactions found for your current filter."
                  img="/upload/notfound.png"
                />
              </TableCell>
            </TableRow>
          )}
        </Table>
      </TableContainer>
    </Scrollbar>
  );

  const DenseSwitchControl = (
    <Tooltip title="Dense padding">
      <Switch checked={dense} onChange={handleChangeDense} />
    </Tooltip>
  );

  return (
    <Page title="Transaction: Electricity Bill">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Electricity Subscription Transactions"
          links={[{ name: 'Dashboard', href: PATH_DASHBOARD.general.app }, { name: 'List' }]}
        />
        <Card sx={{ p: 3, borderRadius: 4, boxShadow: 3 }}>
          {/* Status Tabs - compact pill and centered */}
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                display: 'inline-flex',
                borderRadius: 999,
                px: 1,
                py: 0.5,
                background: (theme) =>
                  theme.palette.mode === 'light' ? theme.palette.background.neutral : theme.palette.grey[900],
                minHeight: 48,
                maxWidth: '100%',
                boxShadow: 'none',
                border: 'none',
              }}
            >
              <Tabs
                value={status}
                onChange={handleStatusChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                TabIndicatorProps={{
                  sx: { display: 'none' },
                }}
                sx={{
                  minHeight: 40,
                  '& .MuiTab-root': {
                    minWidth: 100,
                    px: 2,
                  },
                }}
              >
                {ACCOUNT_TABS.map((tab) => (
                  <Tab
                    disableRipple
                    key={tab.value}
                    label={capitalCase(tab.label)}
                    value={tab.value}
                    sx={{
                      minWidth: 70,
                      px: 1.5,
                      py: 1,
                      borderRadius: 999,
                      fontWeight: 600,
                      fontSize: 16,
                      color: status === tab.value ? theme.palette.primary.contrastText : getTabColor(tab.value),
                      background: status === tab.value ? theme.palette.primary.main : getTabBackground(tab.value),
                      boxShadow: 'none',
                      border: 'none',
                      zIndex: status === tab.value ? 1 : 0,
                      transition: 'all 0.2s',
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          </Box>
          {/* Modern Toolbar */}
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 2, px: 1 }}>
            <PlanToolbar filterName={filterName} onFilterName={handleFilterByName} />
            <Stack direction="row" spacing={1}>
              <Tooltip title="Export">
                <IconButton color="primary">
                  <Iconify icon="eva:download-outline" width={24} height={24} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Filter">
                <IconButton>
                  <Iconify icon="ic:round-filter-list" width={24} height={24} />
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
          {/* Conditional Rendering - Table for Desktop, Accordion for Mobile */}
          {isMobile ? renderMobileView() : renderDesktopView()}
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 2 }}>
            {!isMobile && <FormControlLabel control={DenseSwitchControl} label="Dense" sx={{ ml: 1 }} />}
            <Box sx={{ flexGrow: 1 }} />
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={totalPage}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ border: 0 }}
            />
          </Stack>
        </Card>
      </Container>
    </Page>
  );
}
